import { createContext, useContext, useMemo } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { FullPageLoader } from '@shared/components/LoadingSpinner';
import { useTenantBootstrap } from '../hooks/useTenantBootstrap';
import { TenantWarningBanner } from './TenantWarningBanner';

const KeycloakContext = createContext(null);
export const useKeycloak = () => {
  const context = useContext(KeycloakContext);
  if (!context) {
    throw new Error('useKeycloak must be used within KeycloakProvider');
  }
  return context;
};

function KeycloakContent({ children }) {
  const { keycloak, initialized, idpHint, domainWarning, dismissDomainWarning, extendSession, logoutForIdle } =
    useTenantBootstrap();

  const contextValue = useMemo(
    () => ({ keycloak, initialized, idpHint, extendSession, logoutForIdle }),
    [keycloak, initialized, idpHint, extendSession, logoutForIdle],
  );

  if (!initialized) {
    return <FullPageLoader />;
  }

  return (
    <KeycloakContext.Provider value={contextValue}>
      <TenantWarningBanner show={domainWarning} onDismiss={dismissDomainWarning} />
      {children}
    </KeycloakContext.Provider>
  );
}

export function KeycloakProvider({ children }) {
  return (
    <BrowserRouter>
      <KeycloakContent>{children}</KeycloakContent>
    </BrowserRouter>
  );
}
